import React, { useEffect, useState } from 'react'
import { useRecoilValue } from 'recoil'
import styled from 'styled-components'
import { isGetJobRecommendAIState, isUpdateUserAfterSaveState } from '../../../../recoil/states/default'
import { hexToRgba } from '../../../../utils/hexToRgba'
import Carousel from './carousel'
import { getJobRecommendAIStorage, getUserStorage } from '../../../../utils/localStorage'
import bg_cord from '../../../../assets/images/home/bg_cord.jpg'

const AIRecommend = () => {
    const isGetJobRecommendAI = useRecoilValue(isGetJobRecommendAIState)
    const isUpdateUser = useRecoilValue(isUpdateUserAfterSaveState)
    const bg = bg_cord//'https://redcross.or.th/wp-content/uploads/2017/10/BG_cord.jpg?id=128'
    const Banner = styled.div`
        background: linear-gradient(0deg, ${hexToRgba('#e1b51c')}, ${hexToRgba('#e1b51c')}), url(${bg});
        object-fit: cover;
        background-size: cover;
    `
    const isMobile = window.innerWidth <= 992
    const [jobRecommendAI, setJobRecommendAI] = useState(null)

    useEffect(() => {
        const data = getJobRecommendAIStorage()
        const user = getUserStorage()
        if (user && data) {
            setJobRecommendAI(data)
        } else {
            setJobRecommendAI(null)
        }
    }, [isGetJobRecommendAI, isUpdateUser])

    return (
        <>
            {jobRecommendAI?.length > 0 &&
                <>
                    {isMobile &&
                        <div className='home-scope2-mobile'>
                            <div className="title-mobile px-3 py-2">
                                <div className="title">ตำแหน่งงานที่แนะนำด้วย AI</div>
                            </div>
                        </div>}
                    <Banner className='home-scope2'>
                        {!isMobile && <div className="container margin-auto div-title flex justify-between items-center px-3">
                            <div className="title">ตำแหน่งงานที่แนะนำด้วย AI</div>
                        </div>
                        }
                        <div className="div-carousel relative">
                            <Carousel jobRecommendAI={jobRecommendAI} />
                        </div>
                    </Banner>
                </>
            }
        </>
    )
}

export default AIRecommend